<template>
  <div class="products">
    <v-app id="products">
      <div>    
        <v-layout align-center justify-center>
          <v-spacer></v-spacer>
          <v-card-title>
            <b>{{ $route.params.slug | uppercase }} {{ $t('category_products') }}</b>
          </v-card-title>
          <v-spacer></v-spacer>
          <!-- <v-card-title>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="ma-2" v-on="on" rounded small color="green lighten-4">
                  Sort<v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                    <v-list-item-title>
                      <b class="click" @click="sort('name')">Name</b>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title>
                      <b class="click" @click="invertPriceSort()">Price</b>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title>
                      <b class="click" @click="invertRatingSort()">Rating</b>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title>
                      <b class="click" @click="invertNearestSort()">Nearest</b>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title>
                      <b class="click" @click="invertLatestSort()">Latest</b>
                    </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="ma-2" v-on="on" rounded small color="blue lighten-4">
                  Order<v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title><b class="click" style="pointer-events: fill;">Asc</b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title><b class="click" style="pointer-events: fill;">Desc</b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title> -->
        </v-layout>
        <div class="container is-fluid">
          <div class="columns is-multiline">
            <div class="hidden-sm-and-down">
              <div class="column is-12">
                <div class="label title is-3">{{ $t('category_filters') }} :</div>
                <v-text-field v-model="search" append-icon="mdi-magnify" :label="'Search ' + '(' + filteredProducts.length + ') Items'" single-line  style="width: 80%"></v-text-field>
                <v-menu bottom offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mt-2 mb-2" v-on="on" rounded medium color="indigo lighten-1" style="width: 80%;" dark outlined>{{ $t('category_subcategory') }}
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item v-for="sub in subpro" :key="sub.id">
                      <router-link :to="'/subcategories/'+ sub.slug">
                        <v-list-item-title>
                          <b>{{sub.name | capitalize}}</b>
                        </v-list-item-title>
                      </router-link>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <select v-model="townFilter" class="select-css" style="border-radius: 25px; width: 80%">
                  <option value="All" selected>
                    <b v-if="townFilter !== 'All'">{{ $t('category_all') }}</b>
                    <b v-if="townFilter === 'All'">{{ $t('category_province') }}</b>
                  </option>
                  <option value="lusaka">Lusaka</option>
                  <option value="Lusaka District">Central</option>
                  <option value="central">Copperbelt</option>
                  <option value="central">Southern</option>
                  <option value="central">Eastern</option>
                  <option value="central">Western</option>
                  <option value="central">North-Western</option>
                  <option value="central">Luapula</option>
                  <option value="central">Northern</option>
                  <option value="central">Muchinga</option>
                </select>
                <p style="margin-bottom: 7px;"></p>
                <select v-model="typeFilter" class="select-css" style="border-radius: 25px; width: 80%">
                  <option value="All" selected>
                    <b v-if="typeFilter !== 'All'">{{ $t('category_all') }}</b>
                    <b v-if="typeFilter === 'All'">{{ $t('category_type') }}</b>
                  </option>
                  <option value="new">{{ $t('category_type_new') }}</option>
                  <option value="discount">{{ $t('category_type_discount') }}</option>
                  <option value="">{{ $t('category_type_rated') }}</option>
                  <option value="">{{ $t('category_type_reviewed') }}</option>
                  <option value="giveaway">{{ $t('category_type_sale') }}</option>
                </select>
                <span v-if="typeFilter != 'giveaway'"><v-checkbox v-model="typeFilter" label="Show Only Popular Items" color="indigo darken-3" value="giveaway" input-value="true"></v-checkbox></span>
                <span v-if="typeFilter == 'giveaway'"><v-checkbox v-model="typeFilter" label="Show Only Popular Items" color="grey darken-3" value="All" input-value="false"></v-checkbox></span>
              </div>
            </div>
            <div class="hidden-md-and-up">
              <div class="column is-12">
                <div class="columns">
                  <div  class="column is-6">
                     <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Products" single-line hide-details></v-text-field>
                  </div> 
                </div>
              </div>
              <v-divider></v-divider>
            </div> 
            <div class="column is-3" v-for="product in filteredProducts" :key="product.id">
              <product :product="product"/>
            </div>
          </div>
        </div>
      </div>
      <generalfab />
    </v-app>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import {fb,db} from '@/firebase'
  
  export default {
    name : "products",
    data: () => ({
      subpro: [],
      townFilter: 'All',
      typeFilter: 'All',
      search: '',
      quantityValue: 1
    }),

    created(){
      this.uid = fb.auth().currentUser.uid

      db.collection('subcategory_products')
      .where('Cat_slug', '==', this.$route.params.slug)
      .get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let sub = doc.data()
          sub.id =  doc.id
          this.subpro.push(sub) 
        })
      })
    },

    mounted() {
      this.initCategory(this.$route.params.slug)
    },

    computed: {
      ...mapState('mainCategoryModule', ['products']),
      ...mapGetters({ category: 'mainCategoryModule/category'}),

      userIsAuthenticated () {
        return this.uid !== null && this.uid !== undefined
      },

      filteredProducts() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.products.filter(product =>
            (product.name + product.client).match(regexp))
        }
        
        const townFilter = entry => 
        (this.townFilter == 'All') ||
        (entry.town_code === this.townFilter)

        const typeFilter = entry => 
        (this.typeFilter == 'All') ||
        (entry.product_key === this.typeFilter)

        const reducer = (accumulator, entry) => {
          if (townFilter(entry) && typeFilter(entry))
            accumulator.push(entry);
          return accumulator;
        }
        return this.products.reduce(reducer, [])
      }
    },

    watch: {
      '$route.params.slug': () => {
        this.initCategory(this.$route.params.slug)
      },
      category() {
        if (this.category.id) {
          this.initProducta(this.category.id)
        }
      }
    },

    methods: {
      getImage(productImages){
        return productImages[0]
      },

      goToSignIn(){
        this.$router.push('/signin')
      },

      addToProductCart(){
        db.collection('cartitems').add({
            product_name: this.product.name,
            product_image: this.product.productImages,
            product_price: this.product.price,
            client_name: this.product.client,
            client_town: this.product.town_code,
            product_quantity: this.quantityValue,
            product_total: this.total,
            product_id: this.product.id,
            user: this.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'product added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },

      ...mapActions('mainCategoryModule', 
        [ 
          'initCategory', 
          'initProducta'
        ]
      ),

      back(){
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  .select-css {
    display: block;
    font-size: 16px;
    font-family: sans-serif;
    font-weight: 700;
    color: #444;
    line-height: 1.3;
    padding: .6em 1.4em .5em .8em;
    width: 100%;
    max-width: 100%; /* useful when width is set to anything other than 100% */
    box-sizing: border-box;
    margin: 0;
    border: 1px solid #aaa;
    box-shadow: 0 1px 0 1px rgba(0,0,0,.04);
    border-radius: .5em;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    /* note: bg image below uses 2 urls. The first is an svg data uri for the arrow icon, and the second is the gradient. 
      for the icon, if you want to change the color, be sure to use `%23` instead of `#`, since it's a url. You can also swap in a different svg icon or an external image reference
      
    */
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
      linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
    background-repeat: no-repeat, repeat;
    /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
    background-position: right .7em top 50%, 0 0;
    /* icon size, then gradient */
    background-size: .65em auto, 100%;
  }
  /* Hide arrow icon in IE browsers */
  .select-css::-ms-expand {
    display: none;
  }
  /* Hover style */
  .select-css:hover {
    border-color: #888;
  }
  /* Focus style */
  .select-css:focus {
    border-color: #aaa;
    /* It'd be nice to use -webkit-focus-ring-color here but it doesn't work on box-shadow */
    box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
    box-shadow: 0 0 0 3px -moz-mac-focusring;
    color: #222; 
    outline: none;
  }

  /* Set options to normal weight */
  .select-css option {
    font-weight:normal;
  }

  /* Support for rtl text, explicit support for Arabic and Hebrew */
  *[dir="rtl"] .select-css, :root:lang(ar) .select-css, :root:lang(iw) .select-css {
    background-position: left .7em top 50%, 0 0;
    padding: .6em .8em .5em 1.4em;
  }

  /* Disabled styles */
  .select-css:disabled, .select-css[aria-disabled=true] {
    color: graytext;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22graytext%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
      linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%);
  }

  .select-css:disabled:hover, .select-css[aria-disabled=true] {
    border-color: #aaa;
  }
</style>